import React from 'react';
import { CancelButton, ModalFooter, XMarkCont } from './ModalFooter.styles';
import CloseMark from '@/assets/icons/closeMark.svg?react';

const ScheduleModalFooter = () => {
  return (
    <ModalFooter id="ModalFooter">
      <CancelButton data-testid="cancel-button" id="CancelButton">
        <XMarkCont>
          <CloseMark />
        </XMarkCont>
        Close preview
      </CancelButton>
    </ModalFooter>
  );
};

export default ScheduleModalFooter;
